import { IndicatorStatusEnum } from '@api/indicatorsApiHandler';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: AssessmentScoresSliceState = {
  chartSelectedAssessment: null,
  loadingScores: true,
  chartSelectedIndicator: null,
};

const assessmentScoresSlice = createSlice({
  name: 'assessmentScores',
  initialState,
  reducers: {
    setChartSelectedAssessmentDetails: (
      state,
      action: PayloadAction<SelectedChartAssessmentInterface | null>,
    ) => ({
      ...state,
      chartSelectedAssessment: action.payload,
    }),

    setLoadingScores: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loadingScores: action.payload,
    }),

    setChartSelectedIndicatorDetails: (
      state,
      action: PayloadAction<SelectedIndicatorInterface | null>,
    ) => ({
      ...state,
      chartSelectedIndicator: action.payload,
    }),

    resetAssessmentScores: () => initialState, // Resets to initial state
  },
});

interface AssessmentScoresSliceState {
  chartSelectedAssessment: SelectedChartAssessmentInterface | null;
  loadingScores: boolean;
  chartSelectedIndicator: SelectedIndicatorInterface | null;
}

export interface SelectedChartAssessmentInterface {
  assessmentId: number;
  date: string;
  index: number;
  score: number;
  questionnaireId: number;
  questionnaireName: string;
}

export interface SelectedIndicatorInterface {
  id: number;
  indicatorId: number;
  score: number;
  scoreSourceText: string;
  indicatorName: string;
  status: IndicatorStatusEnum;
  isPositive: boolean;
}

export const {
  setChartSelectedAssessmentDetails,
  setLoadingScores,
  setChartSelectedIndicatorDetails,
  resetAssessmentScores,
} = assessmentScoresSlice.actions;

export default assessmentScoresSlice;
